import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import PersonalInformation from './pages/PersonalInformation';
import EducationBackground from './pages/EducationBackground';
import WorkExperience from './pages/WorkExperience';
import SkillsCertifications from './pages/SkillsCertifications';
import InstituteDetails from './pages/InstituteDetails';
import VacancyDetails from './pages/VacancyDetails'
import ContactUs from './pages/ContactUs';
import Dashboard from './pages/Dashboard';
function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route 
              path="/personal-information" 
              element={
                <ProtectedRoute allowedRoles={['teacher']}>
                  <PersonalInformation />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/education-background" 
              element={
                <ProtectedRoute allowedRoles={['teacher']}>
                  <EducationBackground />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/work-experience" 
              element={
                <ProtectedRoute allowedRoles={['teacher']}>
                  <WorkExperience />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/skills-certifications" 
              element={
                <ProtectedRoute allowedRoles={['teacher']}>
                  <SkillsCertifications />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/institute-details" 
              element={
                <ProtectedRoute allowedRoles={['institution']}>
                  <InstituteDetails />
                </ProtectedRoute>
              } 
            />
             <Route 
              path="/vacancy-details" 
              element={
                <ProtectedRoute allowedRoles={['institution']}>
                  <VacancyDetails />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute allowedRoles={['teacher']}>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="/" element={<LandingPage isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />} />
          </Routes>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                marginTop: "4rem",
                background: '#E97132',
                color: '#FDF1EA',
              },
              success: {
                style: {
                  background: '#E97132',
                },
              },
              error: {
                style: {
                  background: '#DC2626',
                },
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;